import { useMutation } from '@tanstack/react-query';
import { deleteAllProducts } from './apiDeleteAllProducts';
import { useDispatch } from 'react-redux';
import { globalError } from '../../store/notifications/actions';
import { invalidateLibraryManagedProductGroupProducts } from './useLibraryManagedProductGroupProducts';

export const useDeleteAllProducts = (productGroupId: string) => {
    const dispatch = useDispatch();

    return useMutation(deleteAllProducts, {
        onSuccess: () => {
            invalidateLibraryManagedProductGroupProducts(productGroupId).then();
        },
        onError: (error: any) => {
            dispatch(globalError(error));
        }
    });
};
